(() => {
  const quoteUrl = '/pages/contact?view=select-your-collection';
  const roiUrl = '/pages/linen-value-calculator';
  const specUrl = '/pages/contact?view=specification-lab';
  const summaryUrl = '/pages/contact?view=specification-summary';
  const shortlistStorageKey = 'bbc-enquiry-shortlist-v1';
  const roiStorageKey = 'bbc-linen-value-baseline-v1';
  const specStorageKey = 'bbc-specification-lab-v1';
  const briefDraftStorageKey = 'bbc-brief-draft-v1';
  const tierRoutes = {
    'BBC Select': { url: '/collections/bbc-select', label: 'Explore Select' },
    'BBC Signature': { url: '/collections/bbc-signature', label: 'Explore Signature' },
    'BBC Reserve': { url: '/collections/bbc-reserve', label: 'Explore Reserve' }
  };

  if (window.location.pathname === '/cart') {
    window.location.replace(quoteUrl);
    return;
  }

  const exactText = new Map([
    ['01 Select your Collection', 'My Collection'],
    ['Select your Collection', 'My Collection'],
    ['Select your Collection.', 'My Collection.'],
    ['Your selected Collection', 'My Collection'],
    ['Your selected Collection.', 'My Collection.'],
    ['Your Collection', 'My Collection'],
    ['Continue with my requirements', 'Open My Collection'],
    ['Send My Requirements', 'Send My Collection to BBC'],
    ['Send my requirements', 'Send My Collection to BBC'],
    ['Add to Collection', 'Add to My Collection'],
    ['Edit selected Collection', 'Edit My Collection'],
    ['Your property and Collection', 'Property and selected products']
  ]);

  const replacePhrases = (value) => String(value || '')
    .replace(/your selected Collection/g, 'My Collection')
    .replace(/selected Collection/g, 'My Collection')
    .replace(/your Collection/g, 'My Collection')
    .replace(/Select your Collection/g, 'My Collection')
    .replace(/Add to Collection/g, 'Add to My Collection')
    .replace(/practical textile-care support/g, 'hospitality support');

  const readSessionJson = (key) => {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); }
    catch (error) { return null; }
  };

  const writeSessionJson = (key, value) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  };

  const clearCompletedRfqSession = () => {
    // Preserve the collection and brief draft: Shopify's success response does not
    // independently verify that an email was received by BBC.
  };

  const ensureLink = (card, url, label, className) => {
    if (!card || card.querySelector('a.' + className)) return;
    const link = document.createElement('a');
    link.className = className;
    link.href = url;
    link.textContent = label;
    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = ' →';
    link.appendChild(arrow);
    const content = card.querySelector('.bbc-m3-card__content') || card;
    content.appendChild(link);
  };

  const normalizeNode = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const nodes = root.querySelectorAll ? root.querySelectorAll('h1,h2,h3,strong,p,span,a,button,small,legend') : [];
    nodes.forEach((element) => {
      if (element.children.length > 0) return;
      const current = element.textContent.trim();
      if (exactText.has(current)) {
        element.textContent = exactText.get(current);
        return;
      }
      const updated = replacePhrases(current);
      if (updated !== current) element.textContent = updated;
    });

    const links = root.querySelectorAll ? root.querySelectorAll('a[href]') : [];
    links.forEach((link) => {
      const href = link.getAttribute('href') || '';
      if (href === '/pages/roi-calculator' || href === '/pages/roi-calculator/') link.setAttribute('href', roiUrl);
    });

    const attrNodes = root.querySelectorAll ? root.querySelectorAll('[aria-label],[title]') : [];
    attrNodes.forEach((element) => {
      ['aria-label', 'title'].forEach((name) => {
        if (!element.hasAttribute(name)) return;
        const before = element.getAttribute(name);
        const after = replacePhrases(before);
        if (after !== before) element.setAttribute(name, after);
      });
    });

    const routeCards = root.querySelectorAll ? root.querySelectorAll('.bbc-collection-route') : [];
    routeCards.forEach((card) => {
      const heading = card.querySelector('h3') && card.querySelector('h3').textContent.trim();
      const route = tierRoutes[heading];
      if (!route || card.querySelector('a')) return;
      const link = document.createElement('a');
      link.href = route.url;
      link.textContent = route.label;
      card.appendChild(link);
    });

    const contentCards = root.querySelectorAll ? root.querySelectorAll('.bbc-m3-card') : [];
    contentCards.forEach((card) => {
      const heading = card.querySelector('h3');
      if (!heading) return;
      const text = heading.textContent.trim();
      if (text === 'My Collection' && !card.querySelector('.bbc-m3-card__link')) ensureLink(card, '/collections/bbc-own-brand', 'Browse BBC Collections', 'bbc-m3-card__link');
      if (text === 'Open My Collection' && !card.querySelector('.bbc-m3-card__link')) ensureLink(card, quoteUrl, 'Open My Collection', 'bbc-m3-card__link');
    });

    const quote = document.querySelector('.bbc-quote');
    if (quote) {
      const pageHeading = quote.querySelector('.bbc-quote__intro > h1');
      if (pageHeading && /select your collection/i.test(pageHeading.textContent)) pageHeading.textContent = 'My Collection.';
      const stageStrong = Array.from(quote.querySelectorAll('.bbc-quote__stage-heading strong')).find((el) => /property and collection/i.test(el.textContent));
      if (stageStrong) stageStrong.textContent = 'Property and selected products';
      const submit = quote.querySelector('.bbc-quote__submit');
      if (submit && /send my requirements/i.test(submit.textContent)) submit.textContent = 'Send My Collection to BBC';
    }
  };

  const injectSavedRoiCalculator = () => {
    if (document.querySelector('[data-roi-calculator]')) return;
    const state = readSessionJson(roiStorageKey);
    if (!state) return;

    const bridge = document.createElement('div');
    bridge.hidden = true;
    bridge.setAttribute('data-roi-calculator', '');
    bridge.setAttribute('data-bbc-roi-bridge', '');

    const values = {
      propertyName: state.propertyName || '',
      scope: state.scope || '',
      rooms: state.rooms || '',
      occupancy: state.occupancy || '',
      method: state.spendMethod || 'annual',
      annualSpend: state.annualisedSpend || '',
      replacementValue: state.replacementValue || '',
      cycleMonths: state.replacementCycle || '',
      horizon: state.horizon || '',
      currency: state.currency || 'ZAR',
      spendBasis: state.spendBasis || ''
    };

    Object.entries(values).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-roi-input', key);
      input.value = value;
      bridge.appendChild(input);
    });
    document.body.appendChild(bridge);
  };

  const readShortlistCount = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(shortlistStorageKey) || '[]');
      return Array.isArray(stored) ? stored.length : 0;
    } catch (error) {
      return 0;
    }
  };

  const journeyStage = () => {
    const path = window.location.pathname;
    const view = new URLSearchParams(window.location.search).get('view') || '';
    if (view === 'specification-summary') return 4;
    if (view === 'specification-lab' || path === '/pages/linen-value-calculator') return 3;
    if (view === 'select-your-collection') return 2;
    if (path.startsWith('/collections/') || path.startsWith('/products/')) return 1;
    return 0;
  };

  const createJourneyRail = () => {
    if (document.querySelector('[data-bbc-professional-journey]')) return;
    const stage = journeyStage();
    if (!stage) return;

    const rail = document.createElement('nav');
    rail.className = 'bbc-professional-journey';
    rail.setAttribute('data-bbc-professional-journey', '');
    rail.setAttribute('aria-label', 'BBC professional linen journey');

    const inner = document.createElement('div');
    inner.className = 'bbc-professional-journey__inner';

    const intro = document.createElement('div');
    intro.className = 'bbc-professional-journey__intro';
    const eyebrow = document.createElement('span');
    eyebrow.textContent = 'Professional linen journey';
    const title = document.createElement('strong');
    title.textContent = 'Build one controlled BBC brief.';
    intro.append(eyebrow, title);

    const steps = document.createElement('ol');
    steps.className = 'bbc-professional-journey__steps';
    const definitions = [
      { number: '01', label: 'Browse & select', href: '/collections/bbc-own-brand' },
      { number: '02', label: 'My Collection', href: quoteUrl, count: true },
      { number: '03', label: 'Plan / specify', href: specUrl },
      { number: '04', label: 'Review & send', href: summaryUrl }
    ];

    definitions.forEach((definition, index) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = definition.href;
      link.className = 'bbc-professional-journey__step';
      if (index + 1 === stage) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'step');
      } else if (index + 1 < stage) {
        link.classList.add('is-complete');
      }
      const number = document.createElement('span');
      number.className = 'bbc-professional-journey__number';
      number.textContent = definition.number;
      const label = document.createElement('span');
      label.className = 'bbc-professional-journey__label';
      label.textContent = definition.label;
      link.append(number, label);
      if (definition.count) {
        const count = document.createElement('span');
        count.className = 'bbc-professional-journey__count';
        count.setAttribute('data-bbc-professional-count', '');
        link.appendChild(count);
      }
      item.appendChild(link);
      steps.appendChild(item);
    });

    inner.append(intro, steps);
    rail.appendChild(inner);
    const main = document.getElementById('MainContent');
    if (main) main.prepend(rail);
  };

  const updateJourneyCount = () => {
    const count = readShortlistCount();
    document.querySelectorAll('[data-bbc-professional-count]').forEach((node) => {
      node.textContent = String(count);
      node.setAttribute('aria-label', `${count} selected ${count === 1 ? 'product' : 'products'}`);
    });
  };

  const specificationLabels = {
    propertyName: 'Property / project',
    propertyType: 'Property / use context',
    operatingEnvironment: 'Room / operating environment',
    guestExpectation: 'Guest expectation / presentation',
    productScope: 'Primary linen area',
    materialPriority: 'Material priority',
    compositionNotes: 'Composition / construction notes',
    laundryArrangement: 'Laundry arrangement',
    weightPreference: 'Weight / absorbency preference',
    careRequirements: 'Care / handling / durability',
    roomCount: 'Room / operating unit count',
    parLevel: 'Par / sets per room or unit',
    dimensions: 'Exact sizes and dimensions',
    replacementContext: 'Replacement / project context',
    requiredDate: 'Required date / timing',
    sustainabilityRequirements: 'Sustainability / certification requirements',
    notes: 'Additional operating notes'
  };

  const formatSpecification = (state) => {
    if (!state || !state.specification) return '';
    const lines = Object.entries(specificationLabels)
      .map(([key, label]) => state.specification[key] ? `${label}: ${state.specification[key]}` : '')
      .filter(Boolean);
    if (!lines.length) return '';
    return [
      'BBC SPECIFICATION LAB — CUSTOMER WORKING SPECIFICATION',
      ...lines,
      '',
      'Customer-supplied working specification for BBC human review. Not a quotation, recommendation, warranty, price confirmation or technical approval.'
    ].join('\n');
  };

  const quoteField = (form, name) => form?.elements.namedItem(name) || null;

  const saveRfqDraft = () => {
    const form = document.querySelector('.bbc-quote__form');
    if (!form) return;
    const read = (name) => {
      const field = quoteField(form, name);
      return field && typeof field.value === 'string' ? field.value : '';
    };
    writeSessionJson(briefDraftStorageKey, {
      organisation: read('contact[organisation]'),
      name: read('contact[name]'),
      role: read('contact[role]'),
      email: read('contact[email]'),
      phone: read('contact[phone]'),
      buyerType: read('contact[buyer_type]'),
      location: read('contact[location]'),
      roomCount: read('contact[room_count]'),
      quantity: read('contact[quantity]'),
      categories: Array.from(form.querySelectorAll('.bbc-quote__category-options input[type="checkbox"]:checked')).map((input) => input.value),
      primaryRange: read('contact[range]'),
      dimensions: read('contact[dimensions]'),
      laundryArrangement: read('contact[laundry_arrangement]'),
      requiredDate: read('contact[required_date]'),
      body: read('contact[body]'),
      savedAt: new Date().toISOString()
    });
  };

  const restoreRfqDraft = (form) => {
    const draft = readSessionJson(briefDraftStorageKey);
    if (!draft || !form) return;
    const restore = (name, value, force = false) => {
      if (!value) return;
      const field = quoteField(form, name);
      if (!field) return;
      if (force || !field.value) field.value = value;
    };
    restore('contact[organisation]', draft.organisation);
    restore('contact[name]', draft.name);
    restore('contact[role]', draft.role);
    restore('contact[email]', draft.email);
    restore('contact[phone]', draft.phone);
    restore('contact[buyer_type]', draft.buyerType, true);
    restore('contact[location]', draft.location);
    restore('contact[room_count]', draft.roomCount);
    restore('contact[quantity]', draft.quantity);
    if (Array.isArray(draft.categories)) {
      form.querySelectorAll('.bbc-quote__category-options input[type="checkbox"]').forEach((input) => {
        input.checked = draft.categories.includes(input.value);
      });
    }
    restore('contact[range]', draft.primaryRange, true);
    restore('contact[dimensions]', draft.dimensions);
    restore('contact[laundry_arrangement]', draft.laundryArrangement, true);
    restore('contact[required_date]', draft.requiredDate);
    restore('contact[body]', draft.body);
  };

  const syncCalculatorToQuote = (quote) => {
    const state = readSessionJson(roiStorageKey);
    if (!state || !Number.isFinite(Number(state.annualisedSpend))) return;
    const set = (selector, value) => {
      const field = quote.querySelector(selector);
      if (field) field.value = value || '';
    };
    const summary = state.summary || 'Linen value planning details carried from the calculator.';
    const panel = quote.querySelector('[data-quote-calculator]');
    if (panel) {
      panel.hidden = false;
      const text = panel.querySelector('[data-quote-calculator-text]');
      if (text) text.textContent = summary;
    }
    set('[data-quote-calculator-input]', summary);
    set('[data-quote-calculator-scope]', state.scope);
    set('[data-quote-calculator-occupancy]', state.occupancy ? `${state.occupancy}%` : '');
    set('[data-quote-calculator-annualised-spend]', state.annualisedSpend);
    set('[data-quote-calculator-horizon]', state.horizon ? `${state.horizon} years` : '');
    set('[data-quote-calculator-exposure]', state.exposure);
    set('[data-quote-calculator-currency]', state.currency);
    set('[data-quote-calculator-spend-basis]', state.spendBasis);
    set('[data-quote-calculator-replacement-value]', state.replacementValue);
    set('[data-quote-calculator-replacement-cycle]', state.replacementCycle ? `${state.replacementCycle} months` : '');

    const organisation = quote.querySelector('[data-quote-organisation]');
    if (organisation && !organisation.value && state.propertyName) organisation.value = state.propertyName;
    const rooms = quote.querySelector('[data-quote-room-count]');
    if (rooms && !rooms.value && state.rooms) rooms.value = state.rooms;
  };

  const createSpecificationQuoteBridge = (quote) => {
    const form = quote.querySelector('.bbc-quote__form');
    if (!form || form.querySelector('[data-quote-success]')) return;
    restoreRfqDraft(form);

    let hidden = form.querySelector('[data-quote-specification-input]');
    if (!hidden) {
      hidden = document.createElement('textarea');
      hidden.name = 'contact[specification]';
      hidden.hidden = true;
      hidden.setAttribute('data-quote-specification-input', '');
      form.appendChild(hidden);
    }

    const state = readSessionJson(specStorageKey);
    const specificationText = formatSpecification(state);
    if (specificationText) {
      hidden.value = specificationText;
      const specification = state.specification || {};
      const stage = quote.querySelector('[data-quote-stage-scope]');
      const grid = stage?.querySelector('.bbc-quote__stage-grid');
      if (stage && grid && !stage.querySelector('[data-quote-specification]')) {
        const panel = document.createElement('div');
        panel.className = 'bbc-quote__spec-summary';
        panel.setAttribute('data-quote-specification', '');
        const label = document.createElement('p');
        label.className = 'bbc-quote__calculator-label';
        label.textContent = 'Specification Lab included';
        const body = document.createElement('p');
        const property = specification.propertyName || 'Working specification';
        const rooms = specification.roomCount ? ` · ${specification.roomCount} rooms / operating units` : '';
        body.textContent = `${property}${rooms}. This customer-supplied specification will be attached to the brief.`;
        const edit = document.createElement('a');
        edit.href = specUrl + '&source=my-collection';
        edit.textContent = 'Review or edit specification';
        panel.append(label, body, edit);
        stage.insertBefore(panel, grid);
      }

      const fillBlank = (name, value, allowDefault = false) => {
        if (!value) return;
        const field = quoteField(form, name);
        if (!field) return;
        if (!field.value || (allowDefault && field.value === 'Not confirmed')) field.value = value;
      };
      fillBlank('contact[organisation]', specification.propertyName);
      fillBlank('contact[room_count]', specification.roomCount);
      fillBlank('contact[dimensions]', specification.dimensions);
      fillBlank('contact[laundry_arrangement]', specification.laundryArrangement, true);
      fillBlank('contact[required_date]', specification.requiredDate);
      const specificationNotes = String(specification.notes || '').trim();
      fillBlank('contact[body]', specificationNotes || 'Structured BBC Specification Lab brief attached for review.');
    }

    const stage = quote.querySelector('[data-quote-stage-scope]');
    const grid = stage?.querySelector('.bbc-quote__stage-grid');
    if (stage && grid && !stage.querySelector('[data-quote-professional-next]')) {
      const bridge = document.createElement('div');
      bridge.className = 'bbc-quote__professional-next';
      bridge.setAttribute('data-quote-professional-next', '');
      const copy = document.createElement('div');
      const heading = document.createElement('strong');
      heading.textContent = specificationText ? 'Refine the structured specification' : 'Need a structured specification?';
      const body = document.createElement('p');
      body.textContent = specificationText
        ? 'My Collection and these brief details will remain available while you review or refine the Specification Lab brief.'
        : 'Carry these property details and My Collection into the Specification Lab before sending the brief. Your selections and planning information stay with the brief.';
      copy.append(heading, body);
      const link = document.createElement('a');
      link.className = 'button button--secondary';
      link.href = specUrl + '&source=my-collection';
      link.textContent = specificationText ? 'Review Specification Lab' : 'Continue to Specification Lab';
      link.setAttribute('data-quote-open-spec', '');
      bridge.append(copy, link);
      grid.insertAdjacentElement('afterend', bridge);
    }

    syncCalculatorToQuote(quote);
    if (form.dataset.b03HandoffReady !== 'true') {
      form.dataset.b03HandoffReady = 'true';
      form.addEventListener('input', saveRfqDraft);
      form.addEventListener('change', saveRfqDraft);
      form.addEventListener('submit', saveRfqDraft, true);
    }
  };

  const restoreQuoteIntoSpecificationLab = () => {
    const form = document.querySelector('[data-bbc-spec-form]');
    if (!form) return;
    const draft = readSessionJson(briefDraftStorageKey);
    const roi = readSessionJson(roiStorageKey);
    const setBlank = (name, value) => {
      if (!value) return;
      const field = form.elements.namedItem(name);
      if (field && !field.value) field.value = String(value);
    };
    if (draft) {
      setBlank('propertyName', draft.organisation);
      setBlank('roomCount', draft.roomCount);
      setBlank('laundryArrangement', draft.laundryArrangement);
      setBlank('dimensions', draft.dimensions);
      setBlank('requiredDate', draft.requiredDate);
      setBlank('notes', draft.body);
    }
    if (roi) {
      setBlank('propertyName', roi.propertyName);
      setBlank('roomCount', roi.rooms);
    }
  };

  const createSummaryReturnAction = () => {
    const actions = document.querySelector('.bbc-spec-summary__actions');
    if (!actions || actions.querySelector('[data-spec-open-rfq]')) return;
    const link = document.createElement('a');
    link.href = quoteUrl + '&source=specification-lab';
    link.className = 'button';
    link.textContent = 'Open My Collection';
    link.setAttribute('data-spec-open-rfq', '');
    actions.appendChild(link);
  };

  const populateSummaryFromRfqDraft = () => {
    const form = document.querySelector('.bbc-spec-summary__form');
    if (!form || form.querySelector('[data-spec-success]')) return;
    const draft = readSessionJson(briefDraftStorageKey);
    if (!draft) return;

    const fillBlank = (name, value) => {
      if (!value) return;
      const field = form.elements.namedItem(name);
      if (field && !field.value) field.value = String(value);
    };
    fillBlank('contact[name]', draft.name);
    fillBlank('contact[organisation]', draft.organisation);
    fillBlank('contact[email]', draft.email);
    fillBlank('contact[phone]', draft.phone);
    fillBlank('contact[role]', draft.role);

    const contextLines = [
      draft.buyerType ? `Property / enquiry type: ${draft.buyerType}` : '',
      draft.location ? `Location: ${draft.location}` : '',
      draft.quantity ? `Approximate quantity: ${draft.quantity}` : ''
    ].filter(Boolean);

    if (contextLines.length) {
      let context = form.elements.namedItem('contact[rfq_context]');
      if (!context) {
        context = document.createElement('textarea');
        context.name = 'contact[rfq_context]';
        context.hidden = true;
        context.setAttribute('data-spec-rfq-context', '');
        form.appendChild(context);
      }
      context.value = contextLines.join('\n');
    }
  };

  document.addEventListener('submit', (event) => {
    if (event.target && event.target.matches && event.target.matches('[data-bbc-spec-form]')) injectSavedRoiCalculator();
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="view=specification-lab"]');
    if (link && document.querySelector('.bbc-quote__form')) saveRfqDraft();
    if (event.target.closest('[data-bbc-enquiry-add],[data-bbc-enquiry-remove],[data-bbc-enquiry-clear]')) {
      window.setTimeout(updateJourneyCount, 0);
    }
  }, true);

  const run = () => {
    clearCompletedRfqSession();
    normalizeNode(document);
    createJourneyRail();
    updateJourneyCount();
    const quote = document.querySelector('.bbc-quote');
    if (quote) createSpecificationQuoteBridge(quote);
    restoreQuoteIntoSpecificationLab();
    createSummaryReturnAction();
    populateSummaryFromRfqDraft();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  document.addEventListener('shopify:section:load', (event) => {
    clearCompletedRfqSession();
    normalizeNode(event.target);
    createJourneyRail();
    updateJourneyCount();
    const quote = document.querySelector('.bbc-quote');
    if (quote) createSpecificationQuoteBridge(quote);
    restoreQuoteIntoSpecificationLab();
    createSummaryReturnAction();
    populateSummaryFromRfqDraft();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === shortlistStorageKey) updateJourneyCount();
  });

  const startObserver = () => {
    if (!document.body) return;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeNode(node);
        if (node.nodeType === Node.TEXT_NODE && node.parentElement) normalizeNode(node.parentElement);
      }));
      const live = document.querySelector('[data-bbc-enquiry-live]');
      if (live && live.textContent) {
        const updated = replacePhrases(live.textContent);
        if (updated !== live.textContent) live.textContent = updated;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver, { once: true });
})();
